import { isValidGuid } from "./geradorGuid";
import { toUpperCaseFirstChar } from "./stringHelper";

export const isObjNotEmpty = (value: any) => !isObjEmpty(value);

export const isObjEmpty = (value: any, isGuid = false) => {
    switch (typeof value) {
        case 'undefined':
            // case 'null':
            return true;
        case 'object':
            if (value == null) {
                return true;
            }
            if (Array.isArray(value)) {
                return value.length === 0;
            }
            if (value instanceof Date) {
                return isNaN(value.getTime()) || value.getTime() === Date.parse('0001-01-01T00:00:00');
            }
            if (value instanceof File) {
                return value.size <= 0;
            }
            if (JSON.stringify(value) === '{}') {
                return true;
            }
            return Object.keys(value).length === 0;
        case 'number':
            return value === 0 || isNaN(value) || isNaN(parseFloat(value)) || isNaN(parseInt(value));
        case 'string':
            if (isGuid && !isValidGuid(value)) {
                return true;
            }
            value = value.replace(/\s/g, '');
            return value === '' || value === 'undefined' || value === 'null' ||
                value === 'NaN' || value === 'false' || value === '0' ||
                value === '[]' || value === '{}' || value.length === 0;

        case 'function':
            return value.toString().replace(/\s/g, '') === '';
        default:
            return false;
    }
};

export const isObjEmptyOrSpaces = (str: string) => {
    return isObjEmpty(str) || str.match(/^ *$/) !== null;
};

export const fixedEncodeURIComponent = (str: string) => {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
};

export const fixedEncodeURI = (str: string) => {
    return encodeURI(str).replace(/%5B/g, '[').replace(/%5D/g, ']');
};

export const vtCloneObj = (obj: any) => obj ? JSON.parse(JSON.stringify(obj)) : undefined;



export function vtObjToFormData(obj: { [key: string]: unknown; }, ignoreProperties?: string[]): FormData {
    const formData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
        if (ignoreProperties && ignoreProperties.includes(key)) {
            continue;
        }

        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                appendArrayToFormData(formData, key, value);
            } else {
                if (isFile(value)) {
                    formData.append(key, value);
                }

                if (typeof value === "number") {
                    formData.append(key, value.toString().replace('.', ','));
                }

                if (typeof value === "string" || typeof value === "boolean") {
                    formData.append(key, value.toString());
                }


                if (typeof value === "object") {
                    for (const k of Object.keys(value)) {
                        const valueKey = value[k];
                        const nameKey = toUpperCaseFirstChar(key) + `.${k}`;
                        if (isObjNotEmpty(valueKey)) {
                            if (typeof valueKey === "string" || typeof valueKey === "boolean") {
                                formData.append(nameKey, valueKey.toString());
                            }
                            else if (typeof valueKey === "number") {
                                formData.append(key, value.toString().replace('.', ','));
                            } else {
                                formData.append(nameKey, valueKey);
                            }
                        }
                    }
                }

            }
        }
    }
    return formData;
}

export function appendArrayToFormData(
    formData: FormData,
    key: string,
    arr: any[] = []
) {
    if (!arr) return formData;

    for (let i = 0; i < arr.length; i++) {
        const obj = arr[i];

        if (!obj || Object.keys(obj).length == 0 || isObjEmpty(obj)) {
            continue;
        }

        if (isFile(obj)) {
            formData.append(key, obj);
            continue;
        }

        const keyPrefix = `${toUpperCaseFirstChar(key)}[${i}].`;

        for (const subKey of Object.keys(obj)) {
            const subValue = obj[subKey];
            if (isObjNotEmpty(subValue)) {
                const fullKey = `${keyPrefix}${toUpperCaseFirstChar(subKey)}`;
                formData.append(fullKey, subValue.toString());
            }
        }
    }

    return formData;
}

export function vtObjToQueryString(obj?: { [key: string]: any; }): string {

    if (isObjEmpty(obj)) {
        return "";
    }

    let queryString = '';
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    queryString += value.map((v: unknown) => `${encodeURIComponent(key)}=${encodeURIComponent(v as string)}`).join('&');
                } else {
                    queryString += `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`;
                }
                queryString += '&';
            }
        }
    }
    return queryString.slice(0, -1); // remove o último '&'
}

export function isFile(obj: any): obj is File {
    return obj instanceof File;
}

export function hasKey<T extends object, K extends keyof T>(obj: T, key: K): boolean {
    return key in obj;
}

export function hasKeyAndValue<T extends object, K extends keyof T>(
    obj: T,
    key: K,
    value: T[K]
): boolean {
    return obj.hasOwnProperty(key) && obj[key] === value;
}

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export function copyWith<T>(original: T, updates: PartialBy<T, keyof T>): T {
    return { ...original, ...updates };
}
